import { useRef, useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { useMediaQuery } from 'react-responsive'
import apiFetch from '@wordpress/api-fetch'
import { Icon } from '@iconify/react'
import { motion } from 'framer-motion'

function MainVisual() {
  const [movie, setMovie] = useState(null)
  const [moviesp, setMoviesp] = useState(null)
  const [image, setImage] = useState(null)
  const [imagesp, setImagesp] = useState(null)

  const isMD = useMediaQuery({
    query: '(min-width: 768px)',
  })

  const videoRef = useRef(null)

  useEffect(() => {
    apiFetch({
      path: `${import.meta.env.VITE_SITE_URL}/wp-json/myroutes/main_visual`,
    }).then((data) => {
      if (data[0]._type === 'movie') {
        apiFetch({
          path: `${import.meta.env.VITE_SITE_URL}/wp-json/wp/v2/media/${data[0].crb_movie}/`,
        }).then((media) => {
          setMovie(media.source_url)
        })
        apiFetch({
          path: `${import.meta.env.VITE_SITE_URL}/wp-json/wp/v2/media/${data[0].crb_movie_sp}/`,
        }).then((media) => {
          setMoviesp(media.source_url)
        })
      } else if (data[0]._type === 'image') {
        setImage(data[0].crb_image)
        setImagesp(data[0].crb_image_sp)
      }
    })
  }, [])

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playing = true
    }
  }, [videoRef])

  return (
    <>
      <div className="max-w-maximum mx-auto">
        {movie ? (
          <ReactPlayer
            url={isMD ? movie : moviesp}
            muted={true}
            loop={true}
            width={isMD ? '100%' : 'auto'}
            height={'100%'}
            style={{
              aspectRatio: isMD ? '16/9' : '750/1400',
            }}
            config={{
              file: {
                attributes: {
                  autoPlay: true,
                  muted: true,
                  loop: true,
                  playsInline: true,
                },
              },
            }}
            ref={videoRef}
          />
        ) : (
          ''
        )}
        {image ? (
          <img
            src={isMD ? image : imagesp}
            style={{
              aspectRatio: isMD ? '16/9' : '750/1400',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          ''
        )}
        {!movie && !image ? (
          <div
            style={{
              aspectRatio: isMD ? '16/9' : '750/1400',
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <Icon
                icon="mdi:loading"
                className="w-16 h-16"
              />
            </motion.div>
          </div>
        ) : (
          ''
        )}
      </div>
      <style>{`
        video {
          object-fit: cover;
        }
      `}</style>
    </>
  )
}

export default MainVisual
